import { render, staticRenderFns } from "./TestDemoList.vue?vue&type=template&id=10eaf5c1&scoped=true"
import script from "./TestDemoList.vue?vue&type=script&lang=js"
export * from "./TestDemoList.vue?vue&type=script&lang=js"
import style0 from "./TestDemoList.vue?vue&type=style&index=0&id=10eaf5c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10eaf5c1",
  null
  
)

export default component.exports